import styles from './user-card.module.scss';
interface cardProps {
  title: string;
  description: string;
  image?: string;
}
const UserCard = (props: cardProps) => {
  return (
    <>
      <div className={`card ${styles.card}`}>
        {props.image ? (
          <img src={props.image} className={`${styles.cardImage} card-img-top`} alt="" />
        ) : (
          <div
            className={`${styles.cardImage} d-flex align-items-center justify-content-center bg-light text-muted font-weight-bold`}
            style={{ fontSize: '24px', border: '1px solid #dee2e6' }}
          >
            {props.title
              .split(' ')
              .map((n) => n[0])
              .join('')}
          </div>
        )}
        <div className={`card-body ${styles.cardBody}`}>
          <h5 className="card-title">{props.title}</h5>
          <p className="card-text">{props.description}</p>
        </div>
      </div>
    </>
  );
};

export default UserCard;
